import React from 'react';
import { useTranslation } from 'react-i18next';
import './TrackCard.css';

const TrackCard = ({ track, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={`track-card ${track.comingSoon ? 'track-card-coming-soon' : ''}`} onClick={onClick}>
      <div className="track-artwork">
        <img 
          src={track.artwork || '/placeholder-track.jpg'} 
          alt={track.name}
          onError={(e) => {
            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="300"%3E%3Crect fill="%239D4EDD" width="300" height="300"/%3E%3Ctext fill="white" font-family="Arial" font-size="20" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3E' + track.name + '%3C/text%3E%3C/svg%3E';
          }}
        />
        {track.comingSoon ? (
          <div className="track-overlay track-overlay-coming-soon">
            <span className="track-coming-soon-badge">{t('music.comingSoon')}</span>
          </div>
        ) : (
          <div className="track-overlay">
            <span className="track-play-icon">▶</span>
          </div>
        )}
      </div>
      <div className="track-info">
        <h3 className="track-name">{track.name}</h3>
        {track.album && (
          <p className="track-album">{track.album}</p>
        )}
      </div>
    </div>
  );
};

export default TrackCard;


